// Base Styles
import colors from "assets/mavric-theme/base/colors";
import borders from "assets/mavric-theme/base/borders";
import typography from "assets/mavric-theme/base/typography";

// helper functions
import pxToRem from "assets/mavric-theme/functions/pxToRem";

const { inputBorderColor, info, grey, transparent, primary, text } = colors;
const { borderRadius } = borders;
const { size } = typography;

const inputOutlined = {
  styleOverrides: {
    root: {
      color: text.main,
      backgroundColor: transparent.main,
      fontSize: size.sm,
      borderRadius: borderRadius.md,

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: primary.light,
      },

      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: primary.light,
        },
      },
    },

    notchedOutline: {
      borderColor: primary.light,
    },

    input: {
      padding: pxToRem(12),
      backgroundColor: transparent.main,
    },

    inputSizeSmall: {
      fontSize: size.xs,
      padding: pxToRem(10),
    },

    multiline: {
      padding: 0,
    },
  },
};

export default inputOutlined;
